import type { QuerySpec } from '@console/types'
import { useMutation, useQuery } from '@tanstack/react-query'
import { askQuestion, executeQuery } from './api.js'

export function useAskMutation() {
  return useMutation({ mutationFn: (prompt: string) => askQuestion(prompt) })
}

/**
 * `staleTime: 0`. Every other query in this app is happy with a cached answer
 * for a while; this one is the operator asking "what is it *now*", and the
 * `as_of` shown beside the number would be a lie if the number came from a
 * cache. Refetching on mount is the point of a refreshable result URL.
 */
export function useQueryExecution(spec: QuerySpec | null) {
  return useQuery({
    queryKey: ['ask-execute', spec],
    queryFn: () => {
      // Unreachable: `enabled` below gates this on `spec !== null`. Narrowing
      // it here rather than asserting keeps the guarantee checked.
      if (spec === null) throw new Error('No query to execute.')
      return executeQuery(spec)
    },
    enabled: spec !== null,
    staleTime: 0,
    gcTime: 0,
  })
}

/**
 * `useVocabulary` lived here and had no callers. It has moved to
 * `reference/queries.ts` as `useVocabularyPack`, alongside `useVerdicts` —
 * one hook per served endpoint, because two hooks fetching one vocabulary is
 * the drift CON-003 exists to prevent, arriving from inside the console
 * instead of from the platform.
 */
